import * as React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { ssiConfig } from "../../../../utilities/constant";

import { DisclosureModal, SubNav } from "..";

import HouseholdSettingModal from "../../../AddClient/components/HouseholdSettingModal";
import { Settings } from "@material-ui/icons";
import householdActions from "../../../../actions/household.action";

const styles = (theme) => ({
  bottomLink: {
    background: "transparent",
    color: theme.palette.grey[600],
    cursor: "pointer",
    fontSize: 14,
    height: "auto",
    position: "absolute",
    top: "auto",
    left: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      paddingLeft: 39,
      bottom: 13,
    },
    [theme.breakpoints.down("lg")]: {
      left: 0,
      width: '100%',
      textAlign: 'center',
      fontSize: 13
    },
    "&.disclosure": {
      bottom: 40,
    },
    "&.gear": {
      bottom: 80,
      left: 0,
      width: '100%',
      textAlign: 'center'
    },
  },
});

class AddClientNavigation extends React.Component {
  state = {
    advisorConfig: {},
  };

  getAdvisorConfig = (nextProps) => {
    const { user, currentHousehold } = nextProps || this.props;
    if (currentHousehold && currentHousehold.advisorConfig) {
      return { ...currentHousehold.advisorConfig, ...ssiConfig };
    }
    if (user && user.user.advisorConfig) {
      return { ...user.user.advisorConfig, ...ssiConfig };
    }
    return { ...user.advisorConfig, ...ssiConfig };
  };

  updateAdvisorSetting = (fieldName) => (event, newValue) => {
    let newState = { ...this.state.advisorConfig };
    newState[fieldName] = Math.round(newValue * 1000) / 1000;
    this.setState({ advisorConfig: newState });
  };

  saveAdvisorSettingToStore = () => {
    // this.props.dispatch(clientAction.updateAdvisorConfig(this.state.advisorConfig));
    this.props.dispatch(
      householdActions.updateHouseholdSettings(this.state.advisorConfig)
    );
  };

  componentDidMount() {
    this.setState({ advisorConfig: this.getAdvisorConfig() });
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (!this.props.currentHousehold && nextProps.currentHousehold) {
      this.setState({ advisorConfig: this.getAdvisorConfig(nextProps) });
    }
  }

  render() {
    const { app, currentPortfolio, currentHousehold, open, pathname, classes } =
      this.props;

    const { advisorConfig } = this.state;

    const { currentStep } = app;
    const portfolioId = currentPortfolio && currentPortfolio.uuid;
    const householdId =
      (currentPortfolio && currentPortfolio.Household.id) ||
      (currentHousehold && currentHousehold.id);
    const items = [];

    if (householdId && currentStep >= 0) {
      items.push({
        isActive: currentStep === 0,
        isAvailable: true,
        label: "Start",
        path: `/Portal/start/${householdId}`,
      });
    } else {
      items.push({
        isActive: currentStep === 0,
        isAvailable: true,
        label: "Start",
        path: `/Portal/start/`,
      });
    }

    if (householdId && currentStep >= 0) {
      items.push({
        isActive: currentStep === 1,
        isAvailable: true,
        label: "Profile",
        path: `/Portal/household/${householdId}/client/`,
      });
    } else {
      items.push({
        isActive: currentStep === 1,
        isAvailable: true,
        label: "Profile",
        path: `/Portal/new`,
      });
    }

    items.push(
      {
        isActive: currentStep === 2,
        isAvailable: householdId && currentStep >= 2,
        label: "Loss",
        path: `/Portal/household/${householdId}/risk`,
      },
      {
        isActive: currentStep === 3,
        isAvailable: householdId && currentStep >= 3,
        label: "Return",
        path: `/Portal/household/${householdId}/rorreturn`,
      },
      {
        isActive: currentStep >= 4,
        isAvailable: householdId && currentStep >= 4,
        label: "Portfolio",
        path: `/Portal/household/${householdId}/portfolio/${portfolioId || ""}`,
      },
      {
        isActive: currentStep >= 5,
        isAvailable: householdId && currentStep >= 5,
        label: "Summary",
        path: `/Portal/household/${householdId}/summary/${portfolioId || ""}`,
      }
    );

    return (
      <SubNav
        items={items}
        open={open}
        pathname={pathname}
        suffix={
          <React.Fragment>
            <DisclosureModal
              dialogAnchorComponent={
                <span className={`${classes.bottomLink} disclosure`}>
                  DISCLOSURES
                </span>
              }
            />
            {currentStep === 1 && (
              <HouseholdSettingModal
                dialogAnchorComponent={
                  <span className={`${classes.bottomLink} gear`}>
                    <Settings fontSize="default" color={"action"} />
                  </span>
                }
                advisorConfig={advisorConfig}
                saveAdvisorSettingToStore={this.saveAdvisorSettingToStore}
                updateAdvisorSetting={this.updateAdvisorSetting}
              />
            )}
          </React.Fragment>
        }
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    app: state.app,
    currentPortfolio: state.portfolio.currentPortfolio,
    currentHousehold: state.household.currentHousehold,
    user: state.user,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(AddClientNavigation)
);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/AddClientNavigation/index.jsx